import { useEffect, useState } from "react";

export const useGeolocation = () =>{
    const [latitude, setLatitude] = useState(0.00);
    const [longitude, setLongitude] = useState(0.00);

    useEffect(()=>{
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                setLatitude(position.coords.latitude);
                setLongitude(position.coords.longitude);
            });
        }
    },[latitude,longitude]);
    
    return {
        latitude: latitude,
        longitude: longitude,
    };
};